import React, { useState, useEffect } from "react";
import {
  BackArrowButton,
  CancelButton,
  ContinueButton,
  CloseButton,
} from "../../button/Button";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import styles from "./ColumnMapping.module.css";
import commonstyles from "../Forms.module.css";
import swal from "sweetalert";
import {
  getPayableMapping,
  updatePayableMapping,
} from "../../../../Bookclosure/Services/ApiHandler";

const LABEL_FIELDS = [
  "Supplier ID",
  "Supplier Name",
  "Doc Date",
  "Due Days",
  "Due Date",
  "Foreign Currency",
  "Exchange Currency Value",
  "GL Account Code",
  "Business",
  "Business Person Responsible",
  "Provision",
  "Category",
];

const KEY_FIELDS = [
  "supplierID",
  "supplierName",
  "docDate",
  "dueDays",
  "dueDate",
  "foreignCurrency",
  "exchangeCurrencyValue",
  "GLAccountCode",
  "business",
  "businessPersonResponsible",
  "provision",
  "category",
];

const LABEL_TO_KEY = LABEL_FIELDS.reduce((acc, label, index) => {
  acc[label] = KEY_FIELDS[index];
  return acc;
}, {});

const DEFAULT_MAPPING = {
  supplierID: "Supplier code",
  supplierName: "Supplier spmn supname",
  docDate: "Doc Date",
  dueDays: "Due days",
  dueDate: "Due date",
  foreignCurrency: "Doc Currency",
  exchangeCurrencyValue: "Exchange Rate",
  GLAccountCode: "Account Code",
  business: "Business",
  businessPersonResponsible: "Business person responsible",
  provision: "Provision",
  category: "O/s category",
};

const ColumnMapping = ({
  PayableID,
  onContinue,
  onBack,
  onCancel,
  onClose,
  mappedValues,
  setMappedValues,
}) => {
  const [columnOptions, setColumnOptions] = useState([]);

  // const [mappedValues, setMappedValues] = useState(
  //   KEY_FIELDS.reduce((acc, key) => ({ ...acc, [key]: "" }), {})
  // );

  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);

  useEffect(() => {
    const fetchMapping = async () => {
      setLoading(true);
      setApiError(null);

      try {
        const response = await getPayableMapping(PayableID);
        const fields = response?.data?.fields || [];

        setColumnOptions(fields);

        const autoMapped = {};
        KEY_FIELDS.forEach((key) => {
          const defaultValue = DEFAULT_MAPPING[key];
          if (fields.includes(defaultValue)) {
            autoMapped[key] = defaultValue;
          }
        });

        setMappedValues((prev) => {
          const hasAnyValue =
            prev && Object.values(prev).some((value) => value && value !== "");

          if (hasAnyValue) {
            return prev;
          }

          return { ...prev, ...autoMapped };
        });
      } catch (error) {
        console.error("Error fetching Payable mapping:", error);
        setApiError("Failed to load");
      }

      setLoading(false);
    };

    fetchMapping();
  }, [PayableID]);

 useEffect(() => {
  const initial = KEY_FIELDS.reduce(
    (acc, key) => ({ ...acc, [key]: "" }),
    {}
  );

  setMappedValues((prev) => {
    const isInvalid =
      !prev || KEY_FIELDS.some((key) => !prev[key] || prev[key] === "");

    return isInvalid ? initial : prev;
  });
}, [PayableID]); 

  const handleFieldChange = (label, value) => {
    const key = LABEL_TO_KEY[label];
    setMappedValues((prev) => ({ ...prev, [key]: value }));
  };

  const fieldsMapped = KEY_FIELDS.every(
    (key) => mappedValues[key] && mappedValues[key] !== ""
  );

const handleSubmit = async () => {
  if (!fieldsMapped) {
    swal("Error ", "Please fill all required fields.", "error");
    return;
  }

  try {
    setLoading(true);

    await updatePayableMapping(PayableID, mappedValues);

    onContinue();
  } catch (error) {
    console.error("Error updating Payable mapping:", error);

    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to update mapping.";

    swal("Error ❌", errorMessage, "error");
  } finally {
    setLoading(false);
  }
};
  return (
    <div className={commonstyles.backdrop}>
      <div
        className={`${commonstyles.container} ${commonstyles.largeContainer}`}
      >
        <header className={`${commonstyles.header}`}>
          <div className={commonstyles.headerLeft}>
            <BackArrowButton onClick={onBack} />
            <h2 className={commonstyles.heading}>Map Column Headers</h2>
          </div>
          <CloseButton onClick={onClose} />
        </header>

       
          <form className={styles.gridForm}>
            {LABEL_FIELDS.map((label) => (
              <CustomDropdown
                key={label}
                label={label}
                required
                value={mappedValues[LABEL_TO_KEY[label]] || ""}
                onChange={(value) => handleFieldChange(label, value)}
                options={columnOptions}
                placeholder="Select Column"
              />
            ))}
          </form>

          <div className={commonstyles.footer}>
            <CancelButton onClick={onCancel} />

            <ContinueButton
              onClick={handleSubmit}
              disabled={!fieldsMapped || loading || apiError}
            />
          </div>
        </div>
      </div>

  );
};

export default ColumnMapping;
